import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import MainWrapper from "../../helpers/MainWrapper";
import "./styles.less";
import ReviewsSection from "./ReviewsSection";
import ReviewForm from "./ReviewForm";
import { useMediaQuery } from "react-responsive";
import MobileReviewsSection from "./MobileReviewsSection";


declare var root: any;

const Reviews = () => {

  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  return (
    <>
      <MainWrapper menus={true}>
        <ReviewForm />
        {isMobileScreen ? <MobileReviewsSection /> : <ReviewsSection />}
      </MainWrapper>
    </>
  );
};

if (root) {
  ReactDOM.render(<Reviews />, root);
}
